var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc16TrendingDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "m3.613 4.21.094.083L6 6.585l1.293-1.292a1 1 0 0 1 1.32-.083l.094.083L11.5 8.085l.793-.792c.603-.603 1.614-.22 1.701.593L14 8l-.002 3.06-.009.087-.025.119-.024.076-.034.081-.052.098-.067.096-.08.09a1.012 1.012 0 0 1-.112.097l-.11.071-.114.054-.105.035-.117.025-.06.007L13 12h-3c-.852 0-1.297-.986-.783-1.623l.076-.084.792-.793L8 7.415 6.707 8.707a1 1 0 0 1-1.32.083l-.094-.083-3-3a1 1 0 0 1 1.32-1.497Z"
})));
export default SvgIc16TrendingDown;